import React from 'react';
/**
 * PriceDisplay — renders a price in Argentine pesos.
 *
 * All prices on this page are in ARS, so the symbol is always "$". The amount
 * is formatted with the Argentine convention (dot as the thousands separator),
 * matching the source copy (e.g. $29.999).
 */
function formatAmount(amount: number): string {
  // Argentine format: thousands separated by dots (e.g. 29999 -> 29.999).
  return new Intl.NumberFormat('es-AR').format(amount);
}
interface PriceDisplayProps {
  amount: number;
  className?: string;
  /** When true, renders as a struck-through "old" price. */
  strike?: boolean;
  /** Optional smaller currency symbol styling. */
  symbolClassName?: string;
}
export function PriceDisplay({
  amount,
  className = '',
  strike = false,
  symbolClassName = ''
}: PriceDisplayProps) {
  return <span className={`${strike ? 'line-through opacity-60' : ''} ${className}`} aria-label={`$${formatAmount(amount)} ARS`} data-id="element-132">
      <span className={symbolClassName} aria-hidden="true" data-id="element-133">
        $
      </span>
      <span aria-hidden="true" data-id="element-134">{formatAmount(amount)}</span>
    </span>;
}